// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","headerContaiener":"Header_headerContaiener__3NAwZ","team":"Header_team__rhwqe"};